import React, { useState } from "react";
import { Heading, Subheading } from "../../design/heading";
import { useProfessional } from "../../contexts/ProfessionalContext";
import EmptyStateView from "../../components/EmptyStateView";
import ProfessionalGridItem from "./components/ProfessionalGridItem";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import ProfessionalButton from "../../components/ProfessionalButton";

const ProfessionalListPage: React.FC = () => {
  const { professionals, error, loading } = useProfessional();
  const [filteredProfessionals, setFilteredProfessionals] =
    useState(professionals);

  if (loading.list) {
    return <LoadingView title="Loading professionals..." />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <div className="px-4 mx-auto max-w-7xl lg:px-8">
      {/* Page Title */}
      <div className="flex items-end justify-between mb-6">
        <div>
          <Heading className="text-2xl font-bold">Marketplace</Heading>
          <Subheading>Search for experts who can assist you</Subheading>
        </div>
        <ProfessionalButton />
      </div>

      {/* Layout Grid */}
      <div>
        {/* <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-8"> */}
        {/* Sidebar Filters */}
        {/* <div className="sticky hidden lg:block top-4">
          <ProfessionalFilters
            professionals={professionals}
            onFilter={setFilteredProfessionals}
          />
        </div> */}

        {/* Professionals Grid */}
        <div>
          {professionals.length === 0 ? (
            <EmptyStateView
              title="No Professionals"
              message="No professionals match your criteria."
            />
          ) : (
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3">
              {professionals.map((professional) => (
                <ProfessionalGridItem
                  key={professional._id}
                  professional={professional}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfessionalListPage;
